<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="(e) => (refs.form = e)" layout="vertical">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
    </Card>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { initForm, isLoading, onClickModalOk } from "./cancel-form.logic";
import { Card, Form } from "ant-design-vue";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../input/template-builder/TemplateBuilder")),
    },
    props: {
        viewOnly: { default: false },
        form: {},
    },
    setup(props) {
        const route = useRoute();
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        return {
            props,
            data,
            refs,
            isLoading,
            callOnClickModalOk,
        };
    },
});
</script>
